import { render, staticRenderFns } from "./OpenAwardSetupTab.vue?vue&type=template&id=4f65dd75&scoped=true&"
import script from "./OpenAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./OpenAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OpenAwardSetupTab.vue?vue&type=style&index=0&id=4f65dd75&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f65dd75",
  null
  
)

export default component.exports